import * as React from 'react';
import { Button as AriaButton } from 'react-aria-components';
import { useNavigate } from 'react-router-dom';

import { useLogout } from '../../hooks/mutations/useLogout';
import { LogOutIcon, SettingsIcon } from '../../icons';
import logger from '../../lib/logger';
import { PATHS } from '../../paths';
import { cx } from '../../utils/cx';
import AvatarLabelGroup from '../base/avatar/AvatarLabelGroup';
import Dropdown from '../base/Dropdown/Dropdown';

import type { LoggedInUser } from '../../providers/AuthProvider';

interface INavAccountCardProps {
  user: LoggedInUser;
}

const NavAccountCard = ({ user }: INavAccountCardProps) => {
  const navigate = useNavigate();
  const [logout] = useLogout();

  const handleLogout = React.useCallback(async () => {
    try {
      await logout();
      window.location.href = '/';
    } catch (error) {
      logger.error('Failed to logout:', error);
    }
  }, [logout]);

  return (
    <Dropdown.Root>
      <AriaButton
        className={({ isPressed, isFocusVisible }) =>
          cx(
            'ring-secondary relative flex w-full cursor-pointer items-center gap-3 rounded-xl p-3 ring-1 ring-inset transition-colors',
            'hover:bg-primary_hover',
            (isPressed || isFocusVisible) && 'bg-primary_hover'
          )
        }
      >
        <AvatarLabelGroup
          size="md"
          src={user.avatarUrl}
          title={user.name}
          subtitle={user.email}
          contrastBorder={!user.avatarUrl}
        />
      </AriaButton>

      <Dropdown.Popover placement="top">
        <Dropdown.Menu>
          <Dropdown.Item icon={SettingsIcon} onAction={() => navigate(PATHS.SETTINGS)}>
            Settings
          </Dropdown.Item>
          <Dropdown.Item icon={LogOutIcon} onAction={handleLogout}>
            Log out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  );
};

export default NavAccountCard;
